import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getFacilityListAction,
  getProviderProfileDetailAction,
  getPackageDetailNewPopupAction,
  getPackageDetailUpdatePopupAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import { getTagListNetworkAction } from "../../../redux/actions/TestPackageNetworkAction";
import Modal from "react-modal";
import { ConfirmationPackagePopup } from "./ConfirmationPackagePopup";
import CustomPagination from "../../../common/CustomPagination";

const initialHeader = [
  "HA Package Code",
  "HA Package Name",
  "Walk In Price",
  "MRP (Rs.)",
  
];

const newAddHeaderArray = [
  "Visit Type",
  "Agreed Rate",
  "Centre Package Code",
  "Centre Package Name",
  "Gender",
  "Fasting Required",
];

const updateAddHeaderArray = [
  "Visit Type",
  "Agreed Rate",
  "Existing Agreed Rate",
  "Centre Package Code",
  "Centre Package Name",
  "Gender",
  "Fasting Required",
];

export const PackageDetailsPopup = ({
  rowData,
  searchFilter,
  apiParams,
  setRowData,
}) => {
  const dispatch = useDispatch();
  const [newHeaderArray, setNewHeaderArray] = useState(initialHeader);
  const [updateHeaderArray, setUpdateHeaderArray] = useState(initialHeader);
  const [isApproveReject, setIsApproveReject] = useState(null);
  const [newSearchFilterPackage, setNewSearchFilterPackage] = useState({
    ticketId: rowData?.requestID,
    SessionId: rowData?.sessionID,
    page: 1,
    rows: 10,
    SortDirection: "DESC",
    SortColumn: "",
    ActionFlag: "A",
  });
  const [updateSearchFilterPackage, setUpdateSearchFilterPackage] = useState({
    ticketId: rowData?.requestID,
    SessionId: rowData?.sessionID,
    page: 1,
    rows: 10,
    SortDirection: "DESC",
    SortColumn: "",
    ActionFlag: "U",
  });
  const providerPortalDetailReducer = useSelector(
    (state) => state?.providerPortalDetailReducer
  );

  useEffect(() => {
    dispatch(getPackageDetailNewPopupAction(newSearchFilterPackage));
    dispatch(getPackageDetailUpdatePopupAction(updateSearchFilterPackage));
    dispatch(getFacilityListAction("PACKAGE"));
  }, []);

  const handleClose = () => {
    dispatch(getProviderProfileDetailAction({ ...searchFilter, ...apiParams }));
    setRowData(null);
  };

  return (
    <>
      <div className="modal-body" style={{ height: "100%" }}>
        <div className="back-buttondiv" onClick={handleClose}>
          <i className="fa-solid fa-circle-arrow-left"></i>
          <h6 style={{ cursor: "pointer" }}>Back</h6>
        </div>
        <div className="flexbetween_center">
          <h4
            className="font-bold text-highlight"
            style={{ letterSpacing: "1px" }}
          >
            Package Details ({rowData?.providerName})
          </h4>
        </div>
        {providerPortalDetailReducer?.getPackageDetailNewPage?.skuDetails
          ?.length ? (
          <>
            <div className="flexbetween_center">
              <h5 className="mt-4">New Packages</h5>
              <div>
                <input
                  type="checkbox"
                  className="form-check-input"
                  onClick={(e) =>
                    e.target.checked
                      ? setNewHeaderArray([
                          ...newHeaderArray,
                          ...newAddHeaderArray,
                        ])
                      : setNewHeaderArray(initialHeader)
                  }
                  checked={newHeaderArray?.length === 10}
                />
                <label
                  className="margin-right"
                  style={{ marginLeft: "10px", fontWeight: "600" }}
                >
                  Table Extended View
                </label>
              </div>
            </div>
            <div className="table-responsive testDetail_modal __custom__properties mt-4">
              <table className="table">
                <thead>
                  <tr>
                    {newHeaderArray?.map((ele) => {
                      return <th scope="col">{ele}</th>;
                    })}
                    {rowData?.detailType === "PackageDetail" ? <th>Source</th> : <th>App Price</th>}
                    <th>Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {providerPortalDetailReducer?.getPackageDetailNewPage?.skuDetails?.map(
                    (ele, index) => {
                      return (
                        <tr key={index}>
                          <td>{ele?.packageId}</td>
                          <td>{ele?.haPackageName}</td>
                          <td>{ele?.walkInPrice}</td>
                          <td>{ele?.mrp}</td>
                          {newHeaderArray?.length === 10 && (
                            <>
                              <td>
                                {ele?.visitType === "HV"
                                  ? "Home Visit"
                                  : ele?.visitType === "DC"
                                  ? "Centre Visit"
                                  : ele?.visitType === "MIX"
                                  ? "Mix Visit"
                                  : "-"}
                              </td>
                              <td>{ele?.agreedRate}</td>
                              <td>{ele?.centrePackageCode}</td>
                              <td>{ele?.centrePackageName}</td>
                              <td>
                                {ele?.gender === "M"
                                  ? "Male"
                                  : ele?.gender === "F"
                                  ? "Female"
                                  : "Both"}
                              </td>
                              <td>
                                {ele?.fastingRequired === true ? "Yes" : "No"}
                              </td>
                            </>
                          )}
                          {rowData?.detailType === "PackageDetail" ?<td>{ele?.source}</td> : <td>{ele?.appPrice1Graded}</td>}
                          <td>
                            <p
                              className={`status-style ${
                                ele?.requestStatus === "Accepted"
                                  ? "approved"
                                  : ele?.requestStatus === "Rejected"
                                  ? "rejected"
                                  : ele?.requestStatus === "InProgress"
                                  ? "notsubmited-status"
                                  : "pending"
                              }`}
                            >
                              {ele?.requestStatus}
                            </p>
                          </td>
                          <td
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setIsApproveReject({
                                ...ele,
                                agreedRate: ele?.agreedRate
                                  ? ele?.agreedRate
                                  : 0,
                                index: index,
                              });
                            }}
                          >
                            <img src="./images/edit-icon.png" alt="" />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
              <div className="d-flex mt-4">
                {providerPortalDetailReducer?.getPackageDetailNewPage
                  ?.totalRow !== 0 && (
                  <CustomPagination
                    totalCount={
                      providerPortalDetailReducer?.getPackageDetailNewPage
                        ?.totalRow
                    }
                    perPageData={newSearchFilterPackage?.rows}
                    searchFilter={newSearchFilterPackage}
                    setSearchFilter={setNewSearchFilterPackage}
                    apiCall={getPackageDetailNewPopupAction}
                  />
                )}
              </div>
            </div>
          </>
        ) : null}
        {providerPortalDetailReducer?.getPackageDetailUpdatePage?.skuDetails
          ?.length ? (
          <>
            <div className="flexbetween_center">
              <h5 className="mt-4">Existing Packages</h5>
              <div>
                <input
                  type="checkbox"
                  className="form-check-input"
                  onClick={(e) =>
                    e.target.checked
                      ? setUpdateHeaderArray([
                          ...updateHeaderArray,
                          ...updateAddHeaderArray,
                        ])
                      : setUpdateHeaderArray(initialHeader)
                  }
                  checked={updateHeaderArray?.length === 11}
                />
                <label
                  className="margin-right"
                  style={{ marginLeft: "10px", fontWeight: "600" }}
                >
                  Table Extended View
                </label>
              </div>
            </div>
            <div className="table-responsive testDetail_modal __custom__properties mt-4">
              <table className="table">
                <thead>
                  <tr>
                    {updateHeaderArray?.map((ele) => {
                      return <th scope="col">{ele}</th>;
                    })}
                     {rowData?.detailType === "PackageDetail" ? <th>Source</th> : <th>App Price</th>}
                    <th>Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {providerPortalDetailReducer?.getPackageDetailUpdatePage?.skuDetails?.map(
                    (ele, index) => {
                      return (
                        <tr key={index}>
                          <td>{ele?.packageId}</td>
                          <td>{ele?.haPackageName}</td>
                          <td>{ele?.walkInPrice}</td>
                          <td>{ele?.mrp}</td>
                          {/* <td>{ele?.source}</td> */}
                          {updateHeaderArray?.length === 11 && (
                            <>
                              <td>
                                {ele?.visitType === "HV"
                                  ? "Home Visit"
                                  : ele?.visitType === "DC"
                                  ? "Centre Visit"
                                  : ele?.visitType === "MIX"
                                  ? "Mix Visit"
                                  : "-"}
                              </td>
                              <td>{ele?.agreedRate}</td>
                              <td>{ele?.existingAgreedRate}</td>
                              <td>{ele?.centrePackageCode}</td>
                              <td>{ele?.centrePackageName}</td>
                              <td>
                                {ele?.gender === "M"
                                  ? "Male"
                                  : ele?.gender === "F"
                                  ? "Female"
                                  : "Both"}
                              </td>
                              <td>
                                {ele?.fastingRequired === true ? "Yes" : "No"}
                              </td>
                            </>
                          )}
                          {rowData?.detailType === "PackageDetail" ?<td>{ele?.source}</td> : <td>{ele?.appPrice1Graded}</td>}
                          <td>
                            <p
                              className={`status-style ${
                                ele?.requestStatus === "Accepted"
                                  ? "approved"
                                  : ele?.requestStatus === "Rejected"
                                  ? "rejected"
                                  : ele?.requestStatus === "InProgress"
                                  ? "notsubmited-status"
                                  : "pending"
                              }`}
                            >
                              {ele?.requestStatus}
                            </p>
                          </td>
                          <td
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setIsApproveReject({
                                ...ele,
                                agreedRate: ele?.agreedRate
                                  ? ele?.agreedRate
                                  : 0,
                                index: index,
                              });
                            }}
                          >
                            <img src="./images/edit-icon.png" alt="" />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
              <div className="d-flex mt-4">
                {providerPortalDetailReducer?.getPackageDetailUpdatePage
                  ?.totalRow !== 0 && (
                  <CustomPagination
                    totalCount={
                      providerPortalDetailReducer?.getPackageDetailUpdatePage
                        ?.totalRow
                    }
                    perPageData={updateSearchFilterPackage?.rows}
                    searchFilter={updateSearchFilterPackage}
                    setSearchFilter={setUpdateSearchFilterPackage}
                    apiCall={getPackageDetailUpdatePopupAction}
                  />
                )}
              </div>
            </div>
          </>
        ) : null}
      </div>
      <Modal
        isOpen={isApproveReject}
        className="modal-add-user-popup modal-role-user-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <ConfirmationPackagePopup
          isApproveReject={isApproveReject}
          setIsApproveReject={setIsApproveReject}
          rowData={rowData}
          handleClose={handleClose}
          newSearchFilterPackage={newSearchFilterPackage}
          updateSearchFilterPackage={updateSearchFilterPackage}
        />
      </Modal>
    </>
  );
};
